// extracted by mini-css-extract-plugin
export default {"TableLoader":"TableLoader__TableLoader--ysMlI"};